"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("../../../utils");
var PanelCard_1 = __importDefault(require("../../PanelCard"));
var ResultsTable_1 = __importDefault(require("../../ResultsTable"));
var columns_1 = __importStar(require("./columns"));
var R = __importStar(require("ramda"));
var determineMicrobialPassFailResult = function (results) {
    return R.all(R.equals("PASS"), R.values(results)) ? "PASS" : "FAIL";
};
var MicrobialCard = function (_a) {
    var result = _a.result, stateRegulations = _a.stateRegulations, moistureContentPercentage = _a.moistureContentPercentage, density = _a.density, isSolid = _a.isSolid, amountPerPackage = _a.amountPerPackage, amountPerServing = _a.amountPerServing, rest = __rest(_a, ["result", "stateRegulations", "moistureContentPercentage", "density", "isSolid", "amountPerPackage", "amountPerServing"]);
    return (React.createElement(PanelCard_1.default, __assign({}, rest, { panelName: "Microbials", instrumentName: result.instrumentUsed.name, method: result.panel.standardOperatingProcedures[0].name, passFailResult: determineMicrobialPassFailResult(result.results), table: React.createElement(ResultsTable_1.default, { columns: columns_1.default({ addPassFail: rest.addPassFail }), rows: utils_1.buildRows(columns_1.getMicrobialAnalyteValue)({
                parameters: result.instrumentUsed.instrumentParameters.filter(function (_a) {
                    var panel = _a.panel;
                    return panel.id === result.panel.id;
                }),
                stateRegulations: stateRegulations,
                results: result.results,
                moistureContentPercentage: moistureContentPercentage,
                density: density,
                isSolid: isSolid,
                amountPerServing: amountPerServing,
                amountPerPackage: amountPerPackage,
            }) }) })));
};
exports.default = MicrobialCard;
//# sourceMappingURL=index.js.map